// extracted by mini-css-extract-plugin
export var container = "_7s-0";
export var error = "_7s-9";
export var label = "_7s-5";
export var light = "_7s-6";
export var md = "_7s-3";
export var sm = "_7s-2";
export var thin = "_7s-8";
export var thinBold = "_7s-7";
export var vertical = "_7s-4";
export var xs = "_7s-1";